import React from 'react';
import { Icon } from '../ui/Icon.jsx';
import { isSuperAdminSession } from '../../lib/session.js';

// ─── VIEW AS VENDOR ───────────────────────────────────────────────────────────
// Opens the vendor's OWN portal in-place (same component the vendor signs into),
// never a separate admin re-implementation — the same principle as "View as
// customer", so anything added to the vendor portal is available here for free.
//
// Super-admin only, mirroring impersonation everywhere else: the portal exposes
// the vendor's catalogue and lets staff act on their listings.
export function ViewAsVendorButton({ vendor, lang, onClick, style }) {
  const ar = lang === 'ar';
  if (!vendor || !isSuperAdminSession()) return null;
  return (
    <button
      onClick={() => onClick(vendor)}
      title={ar
        ? 'افتح بوابة هذا البائع كما يراها'
        : "Open this vendor's portal exactly as they see it"}
      style={{
        padding: '7px 13px', borderRadius: 7, background: 'var(--sedra-forest)',
        color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12.5,
        fontWeight: 700, whiteSpace: 'nowrap',
        display: 'inline-flex', alignItems: 'center', gap: 6, ...style,
      }}>
      <Icon name="Eye" size={13} /> {ar ? 'عرض كبائع' : 'View as vendor'}
    </button>
  );
}
